import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, Sidebar } from '../Layout';
import { Link } from 'react-router-dom';
import { getClients, destroyClient } from '../../../actions/clientAction'
import { Loading } from '../../shared';
import { clientUpdate } from '../../../actions/clientAction';
import AddUserModal from "./AddUserModal";
import DataTableUsers from './DataTableUsers'

const Client = (props) => {
    const dispatch = useDispatch()
   

    const { loading, clients } = useSelector(state => state.clientStore)
    // const { user } = useSelector(state => state.auth)
    // const authUser = user;

	const [showAddAdminModal, setAddAdminModal] = useState(false);
	const [selectedRowData, setselectedRowData] = useState(false);
	const [inputActionIds, setActionIds] = useState(null);

	const childRef = useRef();

    const handleAddAdminClose = () => {
		setAddAdminModal(false);
		setselectedRowData(false);
	};
	// const [inputAdminData, setAdminData] = useState("");
	// const [inputSelectedCount, setSelectedCount] = useState(0);

    const handleAddAdminShow = () => {
		setselectedRowData(false);
        setAddAdminModal(true);
    };
	const selectedData = (data) => {
		setselectedRowData(data);
		setActionIds([data.userId]);
		setAddAdminModal(true);
	};
	
    const handleSubmitBlockUnblock = (userStatus) => {
        console.log(userStatus ,'change status');
        const updateData ={
            id: userStatus.userId,
            is_blocked: userStatus.status  ? false : true ,
        };
        dispatch(clientUpdate(updateData))
    }
	
	const  setSelectedRowsCount = (newCount) => {
		// setSelectedCount(newCount);
	};
	const  deleteAdminData = async() => {
        if (inputActionIds && inputActionIds.length ) {
            var element;
            for (let index = 0; index < inputActionIds.length; index++) {
                element = inputActionIds[index];
                
            }
            //console.log("inputActionIds", element);
			dispatch(destroyClient(element));
            //window.location.reload();
			handleAddAdminClose();
		} else {
			alert("Please select any admin");
		}
	};
   
    useEffect(() => {
        dispatch(getClients())
	}, [dispatch]);
	
	
    if (loading) {
        return (
            <Loading/>
        );
    }
	
    const findRows = (rows) => {
		setActionIds(rows);
		console.log("checked rows", inputActionIds);
	};
    return (
        <>
            <Header />
            <Sidebar/>
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>User Managment</h2>
                        </div>            
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">User Managment</li>
                            </ul>
                            <button onClick={() => handleAddAdminShow()} className="btn btn-sm button" title="">Create New</button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="header">
                                    <h2>Users </h2>
                                </div>
                                <div className="body py-1">
                                    <div className="table text-center">
                                        <DataTableUsers ref={childRef} data={clients} openModal={selectedData} changeStatus={handleSubmitBlockUnblock} mode='edit'  change={findRows} countRows={setSelectedRowsCount} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddUserModal
                open={showAddAdminModal}
                close={handleAddAdminClose}
                data={selectedRowData}
                onLoad={clients}
                deleteData={deleteAdminData}
            />
        </>
    );
}

export default Client;